import { Tags } from "@/enum/tags";

import { apiSlice } from "../http";
import {
  CreateReasonPayload,
  PriceRemarkReason,
  UpdateReasonPayload,
} from "./types";

export const priceRemarkReasonsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPriceRemarkReasons: builder.query<PriceRemarkReason[], void>({
      query: () => ({
        url: "/price-remark/justification-reasons",
        method: "GET",
      }),
      transformResponse: (response: PriceRemarkReason[]) => response || [],
      providesTags: [Tags.PRICE_REMARK_REASONS],
    }),
    createPriceRemarkReason: builder.mutation<
      PriceRemarkReason,
      CreateReasonPayload
    >({
      query: (body) => ({
        url: "/price-remark/justification-reasons",
        method: "POST",
        body,
      }),
      invalidatesTags: [Tags.PRICE_REMARK_REASONS],
    }),
    updatePriceRemarkReason: builder.mutation<
      PriceRemarkReason,
      { contexto: string; codigo: string; body: UpdateReasonPayload }
    >({
      query: ({ contexto, codigo, body }) => ({
        url: `/price-remark/justification-reasons/${contexto}/${codigo}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: [Tags.PRICE_REMARK_REASONS],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetPriceRemarkReasonsQuery,
  useCreatePriceRemarkReasonMutation,
  useUpdatePriceRemarkReasonMutation,
} = priceRemarkReasonsApi;
